import PropTypes from 'prop-types';

import { AvatarImage } from '../../components/Avatar';

const UserTableAvatar = (props) => {
  const { data } = props;
  if (data.type === 'user') {
    return (
      <div className="user-avatar">
        <AvatarImage borderGray name={data.displayName} alt={data.displayName} fontSize={15} height={35} width={35} initials={2} src={data.alldata.logo} />
      </div>
    );
  }
  return null;
};

UserTableAvatar.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]),
};

export default UserTableAvatar;
